import React, { memo, useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

function NavButton({ children, to, activePath, className = '', mainPath = false, role, isAuth = null, ...props }) {
    const { pathname } = useLocation();

    const isActive = useMemo(() => {
        if (mainPath) {
            if (isAuth) return pathname === `/${role}`;
            return pathname === '/';
        }
        return activePath && pathname.startsWith(activePath);
    }, [pathname, mainPath, role, isAuth, activePath]);

    const navClassName = isActive ? (isAuth ? 'navActive-library' : 'navActive-gray') : '';
    return (
      <NavLink to={to} {...props} className={` ${className} ${navClassName}`}>
          {children}
      </NavLink>
    );
}

export default memo(NavButton);
